import { getEventVariables } from './commandContext.js';

export function getEventContextVariables(sourceNode, event) {
    return getEventVariables(sourceNode, event).map(id => ({
        id,
        token: `{${id}}`,
        type: ['val', 'start'].includes(id) ? 'number' : 'string',
        label: id === 'val' ? 'Value' : id === 'start' ? 'Start value' : id,
        description: id === 'val'
            ? 'Current value of the object that triggered this event'
            : id === 'start'
                ? 'Current start value of the Range object that triggered this event'
            : `${id} supplied by the triggering event`,
        preview: ['val', 'start'].includes(id) ? '50' : id,
    }));
}

export function variablesAcceptedByProperty(sourceNode, event, property) {
    const variables = getEventContextVariables(sourceNode, event);
    if (property?.type === 'string') return variables;
    if (['int', 'float', 'number'].includes(property?.type)) {
        return variables.filter(variable => variable.type === 'number');
    }
    return [];
}

export function validatePropertyContextVariables(value, sourceNode, event, property) {
    const referenced = [...String(value ?? '').matchAll(/\{([A-Za-z_][A-Za-z0-9_]*)\}/g)]
        .map(match => match[1]);
    if (!referenced.length) return '';
    const acceptedVariables = variablesAcceptedByProperty(sourceNode, event, property);
    const accepted = new Set(acceptedVariables.map(variable => variable.id));
    const invalid = referenced.find(id => !accepted.has(id));
    if (invalid) return `{${invalid}} is not available for this property and event`;
    if (property?.type !== 'string' && referenced.length) {
        const completeToken = String(value).match(/^\{([A-Za-z_][A-Za-z0-9_]*)\}$/);
        if (!completeToken) return 'This property only accepts a context variable as the complete value';
    }
    return '';
}
